// extracted by mini-css-extract-plugin
module.exports = {"eye":"CandidateReports_eye__CNbC0"};